// extracted by mini-css-extract-plugin
module.exports = {"Control":"Control-Control-1amhWr","LeftChevron":"Control-LeftChevron-1e8A3Q","RightChevron":"Control-RightChevron-2fa0ap"};